/* Les Saveurs EBS — theme.js
   Comportements repris du template + panier Shopify (AJAX). */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(p) {
    return Number(p).toFixed(2).replace('.', ',') + ' €';
  }

  /* Rend une carte .shop-card à partir d'un produit /search/suggest.json
     (mêmes classes que snippets/product-card-shop.liquid). */
  function renderShopCard(p) {
    var img = p.image ? '<img src="' + p.image + '&width=600" alt="" loading="lazy">' : '';
    return '<article class="shop-card">' +
      '<div class="shop-card__media">' +
        '<a class="product__link" href="' + p.url + '">' + img + '</a>' +
      '</div>' +
      '<div class="shop-card__body">' +
        '<div class="shop-card__head">' +
          '<h3 class="shop-card__name"><a class="product__link" href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
          '<span class="shop-card__price">' + formatPrice(p.price) + '</span>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  /* ---- Recherche prédictive ----
     La page /search de Shopify exige le mot complet ("bou" ne trouve
     pas "Bougie"). L'API /search/suggest.json gère les préfixes,
     donc on l'utilise pour des suggestions en direct pendant la frappe. */
  document.querySelectorAll('[data-predictive-search]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-search-input]');
    var panel = wrap.querySelector('[data-search-results]');
    if (!input || !panel) return;

    var debounceId, controller, lastQuery = '';

    function render(products, query) {
      if (!products.length) {
        panel.innerHTML = '<p class="search-results__empty">Aucun résultat pour « ' + escapeHtml(query) + ' »</p>';
        panel.hidden = false;
        return;
      }
      var html = products.slice(0, 6).map(function (p) {
        var img = p.image ? '<img src="' + p.image + '&width=100" alt="" loading="lazy">' : '';
        return '<a class="search-result" href="' + p.url + '">' +
          '<span class="search-result__media">' + img + '</span>' +
          '<span class="search-result__body">' +
            '<span class="search-result__name">' + escapeHtml(p.title) + '</span>' +
            '<span class="search-result__price">' + formatPrice(p.price) + '</span>' +
          '</span>' +
        '</a>';
      }).join('');
      html += '<a class="search-results__all" href="/search?q=' + encodeURIComponent(query) + '">Voir tous les résultats</a>';
      panel.innerHTML = html;
      panel.hidden = false;
    }

    function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', {
        signal: controller.signal,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, query);
        })
        .catch(function (err) { if (err.name !== 'AbortError') panel.hidden = true; });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      lastQuery = query;
      clearTimeout(debounceId);
      if (query.length < 2) { panel.hidden = true; return; }
      debounceId = setTimeout(function () { search(query); }, 220);
    });

    input.addEventListener('focus', function () {
      if (lastQuery.length >= 2 && panel.innerHTML) panel.hidden = false;
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) panel.hidden = true;
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') panel.hidden = true;
    });
  });

  /* ---- Page résultats de recherche : repli si 0 résultat natif ----
     Même limitation que ci-dessus sur /search?q=. Si Shopify ne
     renvoie rien pour une requête partielle, on retente via l'API
     de suggestion (prefix-friendly) et on affiche ces résultats. */
  document.querySelectorAll('[data-search-fallback]').forEach(function (grid) {
    var query = grid.getAttribute('data-search-query');
    var count = Number(grid.getAttribute('data-search-count'));
    if (!query || count > 0) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) return;
        grid.innerHTML = products.map(renderShopCard).join('');
        var summary = document.querySelector('[data-search-summary]');
        if (summary) summary.textContent = products.length + ' résultat(s) pour « ' + query + ' ».';
      })
      .catch(function () {});
  });

  /* ---- Header au scroll ---- */
  var header = document.getElementById('site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Accordéons (fiche produit) ---- */
  document.querySelectorAll('.accordion summary').forEach(function (s) {
    s.addEventListener('click', function () {
      var d = s.parentElement;
      document.querySelectorAll('.accordion details[open]').forEach(function (o) {
        if (o !== d && o.parentElement === d.parentElement) o.removeAttribute('open');
      });
    });
  });

  /* ---- Favoris (local, sans compte client) ----
     Délégation d'événements : fonctionne aussi pour les cartes
     injectées dynamiquement (repli de recherche ci-dessus). */
  (function () {
    var KEY = 'mg-wishlist';
    var saved;
    try { saved = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { saved = []; }

    function paintCount() {
      document.querySelectorAll('[data-wishlist-count]').forEach(function (b) {
        b.textContent = saved.length;
        b.classList.toggle('is-visible', saved.length > 0);
      });
    }

    function paint(btn) {
      var id = btn.getAttribute('data-wishlist');
      var active = saved.indexOf(id) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    }

    document.querySelectorAll('[data-wishlist]').forEach(paint);
    paintCount();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-wishlist');
      var i = saved.indexOf(id);
      if (i === -1) { saved.push(id); } else { saved.splice(i, 1); }
      try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (err) {}
      document.querySelectorAll('[data-wishlist="' + id + '"]').forEach(paint);
      paintCount();
      var grid = btn.closest('[data-wishlist-grid]');
      var card = btn.closest('[data-wishlist-grid] .shop-card');
      if (card && i !== -1) {
        card.remove();
        if (grid && !grid.children.length) {
          var emptyEl = document.querySelector('[data-wishlist-empty]');
          if (emptyEl) emptyEl.hidden = false;
        }
      }
    });
  })();

  /* ---- Page Mes favoris : rendu à partir du localStorage ---- */
  document.querySelectorAll('[data-wishlist-grid]').forEach(function (grid) {
    var saved;
    try { saved = JSON.parse(localStorage.getItem('mg-wishlist')) || []; } catch (e) { saved = []; }
    var emptyEl = document.querySelector('[data-wishlist-empty]');
    if (!saved.length) { if (emptyEl) emptyEl.hidden = false; return; }

    Promise.all(saved.map(function (handle) {
      return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);

      // Auto-nettoyage : entrées invalides (ex. anciens favoris enregistrés
      // avec l'ID produit avant le passage au handle) — on les retire pour
      // que le badge du header reste cohérent avec ce qui s'affiche ici.
      if (valid.length !== products.length) {
        var validHandles = valid.map(function (p) { return p.handle; });
        try { localStorage.setItem('mg-wishlist', JSON.stringify(validHandles)); } catch (err) {}
        document.querySelectorAll('[data-wishlist-count]').forEach(function (b) {
          b.textContent = validHandles.length;
          b.classList.toggle('is-visible', validHandles.length > 0);
        });
      }

      if (!valid.length) { if (emptyEl) emptyEl.hidden = false; return; }
      grid.innerHTML = valid.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
        return '<article class="shop-card">' +
          '<div class="shop-card__media">' +
            (img ? '<a class="product__link" href="/products/' + p.handle + '"><img src="' + img + '&width=600" alt="" loading="lazy"></a>' : '') +
            '<button class="wishlist is-active" type="button" data-wishlist="' + p.handle + '" aria-label="Retirer des favoris" aria-pressed="true"><svg width="18" height="18" aria-hidden="true"><use href="#i-heart"/></svg></button>' +
          '</div>' +
          '<div class="shop-card__body"><div class="shop-card__head">' +
            '<h3 class="shop-card__name"><a class="product__link" href="/products/' + p.handle + '">' + escapeHtml(p.title) + '</a></h3>' +
            '<span class="shop-card__price">' + price + '</span>' +
          '</div></div>' +
        '</article>';
      }).join('');
    });
  });

  /* ---- Sélecteur de quantité ---- */
  document.querySelectorAll('.qty').forEach(function (qty) {
    var input = qty.querySelector('input[type="number"]');
    if (!input) return;
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var min = Number(input.min) || 1;
      input.value = Math.max(min, (Number(input.value) || min) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (Number(input.value) || 0) + 1;
    });
  });

  /* ---- Menu mobile ---- */
  document.querySelectorAll('[data-burger]').forEach(function (burger) {
    var links = document.getElementById(burger.getAttribute('aria-controls')) ||
                burger.parentElement.querySelector('.nav__links');
    if (!links) return;
    burger.addEventListener('click', function () {
      var open = links.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
    });
    links.addEventListener('click', function (e) {
      if (e.target.closest('a')) { links.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); }
    });
  });

  /* ---- Carrousels ---- */
  function setupCarousel(root) {
    var track = root.querySelector('[data-track]'); if (!track) return null;
    var prev = root.querySelector('[data-dir="-1"]'), next = root.querySelector('[data-dir="1"]');
    function step() { var f = track.firstElementChild; if (!f) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; return f.getBoundingClientRect().width + gap; }
    function sb(dir) { track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }
    function sync() { var max = track.scrollWidth - track.clientWidth - 1; if (prev) prev.disabled = track.scrollLeft <= 1; if (next) next.disabled = track.scrollLeft >= max; }
    [prev, next].forEach(function (b) { if (b) b.addEventListener('click', function () { sb(Number(b.dataset.dir)); }); });
    track.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.style.cursor = 'grabbing'; });
    track.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = sl - dx; });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { track.addEventListener(ev, function () { down = false; track.style.cursor = ''; }); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    return { scrollBy: sb };
  }
  var carousels = new Map();
  document.querySelectorAll('[data-carousel]').forEach(function (root) { var api = setupCarousel(root); if (api && root.hasAttribute('data-gallery')) carousels.set('gallery', api); });
  document.querySelectorAll('[data-gallery-dir]').forEach(function (btn) { btn.addEventListener('click', function () { var api = carousels.get('gallery'); if (api) api.scrollBy(Number(btn.dataset.galleryDir)); }); });

  /* ---- Panier Shopify (AJAX) ---- */
  var badges = document.querySelectorAll('[data-cart-count]');
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        badges.forEach(function (b) {
          b.textContent = c.item_count;
          b.classList.toggle('is-visible', c.item_count > 0);
          b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
        });
      }).catch(function () {});
  }

  function bumpCartIcon() {
    document.querySelectorAll('[data-cart-icon]').forEach(function (el) {
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 500);
    });
  }

  document.querySelectorAll('[data-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var icon = btn ? btn.querySelector('use') : null;
      var originalIcon = icon ? icon.getAttribute('href') : null;
      if (btn) btn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCount();
          bumpCartIcon();
          toast('Ajouté au panier ✓');
          if (btn) {
            btn.classList.add('is-added');
            if (icon) icon.setAttribute('href', '#i-check');
            setTimeout(function () {
              btn.classList.remove('is-added');
              if (icon && originalIcon) icon.setAttribute('href', originalIcon);
            }, 900);
          }
        })
        .catch(function () { toast('Indisponible'); })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    });
  });
  refreshCount();

  /* ---- Partage fiche produit ---- */
  document.querySelectorAll('[data-share]').forEach(function (root) {
    var url = root.dataset.shareUrl, title = root.dataset.shareTitle, text = root.dataset.shareText;
    var trigger = root.querySelector('[data-share-trigger]');
    var menu = root.querySelector('[data-share-menu]');
    if (!trigger || !menu) return;

    var fb = root.querySelector('[data-share-fb]');
    if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    var wa = root.querySelector('[data-share-wa]');
    if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' — ' + url);
    var xShare = root.querySelector('[data-share-x]');
    if (xShare) xShare.href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url);

    trigger.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: title, text: text, url: url }).catch(function () {});
        return;
      }
      menu.hidden = !menu.hidden;
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) menu.hidden = true;
    });

    var copyBtn = root.querySelector('[data-share-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      menu.hidden = true;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { toast('Lien copié ✓'); }).catch(function () {});
      }
    });
  });

  var t;
  function toast(msg) {
    var el = document.getElementById('toast');
    if (!el) { el = document.createElement('div'); el.id = 'toast'; el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('show'); clearTimeout(t); t = setTimeout(function () { el.classList.remove('show'); }, 1600);
  }

  /* ---- Avis : survol = actif ---- */
  var quotes = document.querySelectorAll('.quote');
  quotes.forEach(function (q) { q.addEventListener('mouseenter', function () { quotes.forEach(function (o) { o.classList.remove('is-active'); }); q.classList.add('is-active'); }); });

  /* ---- Reveal ---- */
  var rev = document.querySelectorAll('.reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) { rev.forEach(function (el) { el.classList.add('is-in'); }); }
  else { var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (!en.isIntersecting) return; en.target.classList.add('is-in'); io.unobserve(en.target); }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }); rev.forEach(function (el) { io.observe(el); }); }

  /* ---- Compteurs ---- */
  function animate(el) { var target = parseFloat(el.dataset.count), dec = parseInt(el.dataset.decimals || '0', 10), suf = el.dataset.suffix || '', dur = 1300, start = null; function tick(now) { if (start === null) start = now; var p = Math.min((now - start) / dur, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = (target * e).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(tick); } requestAnimationFrame(tick); }
  var cs = document.querySelectorAll('[data-count]');
  if (!reduceMotion && 'IntersectionObserver' in window) { var co = new IntersectionObserver(function (es) { es.forEach(function (en) { if (!en.isIntersecting) return; animate(en.target); co.unobserve(en.target); }); }, { threshold: 0.6 }); cs.forEach(function (el) { co.observe(el); }); }
})();
